import {
  // reuqestAuthToken,
  // reuqestLoginPhone,
  reuqestGetUserInfo,
  // reuqestAuthSMSCode,
  tokenUserNamePassword,
  tokenMobilePassword,
  tokenMobileCheck,
  tokenEmailCheck,
  accountEmailUser,
  accountMobileUser,
  checkPhone,
  // checkEmail,
  // verifyImage,
  phoneCheckCode,
  emailCheckCode,
  reuqestGetToken,
  reuqestBindBaiDu,
  // reuqestGetLoginLocation,
  accountPasswordUser,
  myself,
  tokenEmailPassword,
  providerAuthLink,
  checkEmail,
} from "../api/login";
import { fileraw } from "../api/file";
import { requestAllSyncCatalogue } from "../api/networkDisk";
import { StorageModule } from "./storage";
import { SocketModule } from "./socket";
import { message } from "antd";
import axios from "axios";
import { getImage } from "../util";

let inter = ""; // 定时器

export const userModule = {
  // 通过手机登录
  // loginByPhone(phone, code) {
  //     return new Promise(async (resolve,reject) => {
  //         const res = await reuqestLoginPhone({
  //             phone,
  //             code
  //         })
  //         if (res?.data?.tokenValue) {
  //             const {
  //                 data: {
  //                     tokenValue,
  //                     // loginId,
  //                 }
  //             } = res
  //             StorageModule.setToken(tokenValue);
  //             axios.interceptors.request.use(
  //                 config => {
  //                     config.headers = { Authorization: StorageModule.getUser().token || tokenValue };
  //                     return config;
  //                 },
  //                 error => {
  //                     return Promise.reject(error);
  //                 }
  //             );
  //             let userinfo = await reuqestGetUserInfo()
  //             let item = userinfo.data.accounts.find((v) => v.accountType.name === 'BAIDU')
  //             if (!item) {
  //                 reject('reject');
  //             }
  //             let type = `data:image/${ userinfo.data.avatarType };base64,`
  //             let user = {
  //                 id: item.id,
  //                 userId: userinfo.data.id,
  //                 avatar: userinfo.data.avatar.includes('http') ? userinfo.data.avatar : type + userinfo.data.avatar,
  //                 serveravatar: userinfo.data.avatarUrl,
  //                 username: userinfo.data.username
  //             }
  //             StorageModule.setUser(user);
  //             userModule.updateUser({
  //                 token: tokenValue,
  //                 user
  //             })
  //             resolve(user);
  //         } else {
  //             reject('error');
  //         }
  //     })
  // },
  // 用户名注册
  regiNamePassword(username, password) {
    return accountPasswordUser({
      username,
      password,
    });
  },
  async setUserInfoByToken(token) {
    StorageModule.setToken(token);
    axios.interceptors.request.use(
      (config) => {
        config.headers = { Authorization: StorageModule.getUser().token || token };
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    let userinfo = await myself();
    // let avatar = await getImage(userinfo.data.avatar);
    let user = {
      ...userinfo.data,
      // avatar
    };
    console.log(userinfo);

    StorageModule.setUser(user);
    userModule.updateUser({
      token: token,
      user, // loginId
    });
    return user;
  },
  // 通过手机密码登录
  phonePasswordLogin(mobile, password) {
    return new Promise(async (resolve, reject) => {
      let res = await tokenMobilePassword({
        mobile,
        password,
        encrypted: true,
      });
      if (res?.data) {
        const user = await userModule.setUserInfoByToken(res?.data);
        resolve(user);
      } else {
        reject("error");
      }
    });
  },
  // 通过邮箱登录
  emailPasswordLogin(email, password) {
    return new Promise(async (resolve, reject) => {
      let res = await tokenEmailPassword({
        email,
        password,
        encrypted: true,
      });
      if (res?.data) {
        const user = await userModule.setUserInfoByToken(res?.data);
        resolve(user);
      } else {
        reject("error");
      }
    });
  },
  // 通过账号登录
  normalLogin(username, password) {
    return new Promise(async (resolve, reject) => {
      let res = await tokenUserNamePassword({
        username,
        password,
        encrypted: true,
      });
      // 错误处理
      if (res.state.code === 400) {
        // 如果不存在重新注册
        if ((res.state.description || "").indexOf("用户名不存在") > -1) {
          res = await userModule.regiNamePassword(username, password);
          if (+res.state.code !== 0) {
            message.error(res.state.description || "注册失败");
            return;
          } else {
            res = await tokenUserNamePassword({
              username,
              password,
              encrypted: true,
            });
          }
        } else {
          // 其他错误
          message.error(res.state.description || "登录错误");
          return;
        }
      }
      if (res?.data) {
        const user = await userModule.setUserInfoByToken(res?.data);
        resolve(user);
      } else {
        reject("error");
      }
    });
  },
  // 通过手机登录
  phoneLogin(code, value, mobile) {
    return new Promise(async (resolve, reject) => {
      let isnew = false;
      try {
        let res = await checkPhone(mobile);
        if (res.code === 404) {
          isnew = true;
        }
      } catch (err) {
        isnew = true;
      }
      let res = {};
      if (isnew) {
        res = await accountMobileUser({ code, value, mobile });
      }
      res = await tokenMobileCheck({ code, value, mobile });
      if (res?.data) {
        const user = await userModule.setUserInfoByToken(res?.data);
        resolve(user);
      } else {
        reject("error");
      }
    });
  },
  // 通过邮箱登录
  emialLogin(code, value, email) {
    return new Promise(async (resolve, reject) => {
      let isnew = false;
      try {
        let res = await checkEmail(email);
        if (res.code === 404) {
          isnew = true;
        }
      } catch (err) {
        isnew = true;
      }
      let res = {};
      if (isnew) {
        res = await accountEmailUser({ code, value, email });
      }
      res = await tokenEmailCheck({ code, value, email });
      if (res?.data) {
        const user = await userModule.setUserInfoByToken(res?.data);
        resolve(user);
      } else {
        reject("error");
      }
    });
  },
  // 百度账号登录
  loginByBaiduAccont({ code, state }) {
    return new Promise(async (resolve, reject) => {
      const isbindbaidu = StorageModule.get("bindbaidu");
      if (isbindbaidu) {
        StorageModule.set("bindbaidu", "");
        await reuqestBindBaiDu(code, state);
        let userinfo = await reuqestGetUserInfo();
        let item = userinfo.data.accounts.find((v) => v.accountType.name === "BAIDU");
        let type = `data:image/${userinfo.data.avatarType};base64,`;
        let user = {
          id: item.id,
          userId: userinfo.data.id,
          avatar: userinfo.data.avatar.includes("http") ? userinfo.data.avatar : type + userinfo.data.avatar,
          serveravatar: userinfo.data.avatarUrl,
          username: item.rawUserInfo.username,
        };
        StorageModule.setUser(user);
        resolve({
          user,
          isbindbaidu,
        });
      }
      let response = await reuqestGetToken({ code, state });
      if (response.state.code === 0) {
        let token = response.data.tokenValue;
        StorageModule.setToken(token);
        axios.interceptors.request.use(
          (config) => {
            config.headers = { Authorization: StorageModule.getUser().token || token };
            return config;
          },
          (error) => {
            return Promise.reject(error);
          }
        );
        let userinfo = await reuqestGetUserInfo();
        let item = userinfo.data.accounts.find((v) => v.accountType.name === "BAIDU");
        let type = `data:image/${userinfo.data.avatarType};base64,`;
        let user = {
          id: item.id,
          userId: userinfo.data.id,
          avatar: userinfo.data.avatar.includes("http") ? userinfo.data.avatar : type + userinfo.data.avatar,
          serveravatar: userinfo.data.avatarUrl,
          username: item.rawUserInfo.username,
        };
        StorageModule.setUser(user);
        userModule.updateUser({
          token: token,
          user, // loginId
        });
        resolve({
          user,
        });
      } else {
        reject("error");
      }
    });
  },
  // 发送验证码，ids用来读秒div，endCb读秒0的回调
  async sendPhoneCode(phone = "", code, value, ids, endCb) {
    const res = await phoneCheckCode(phone, "zwf_verify", code, value);
    clearInterval(inter);
    clearInterval(window.loginInter);
    let count = 60;
    if (ids) {
      if (!(ids instanceof Array)) {
        ids = [ids];
      }
      if (!(endCb instanceof Array)) {
        endCb = [endCb];
      }
      inter = setInterval(() => {
        ids.forEach((v, k) => {
          if (v) {
            const item = document.getElementById(v);
            item.innerHTML = count + "秒";
            count--;
            if (count <= 0) {
              if (endCb[k]) {
                endCb[k]();
              }
              clearInterval(inter);
            }
          }
        });
      }, 1000);
      window.loginInter = inter;
    }
    return res.data;
  },
  async sendMailCode(phone = "", code, value, ids, endCb) {
    const res = await emailCheckCode(phone, "verify_email", code, value);
    clearInterval(inter);
    clearInterval(window.loginInter);
    let count = 60;
    if (ids) {
      if (!(ids instanceof Array)) {
        ids = [ids];
      }
      if (!(endCb instanceof Array)) {
        endCb = [endCb];
      }
      inter = setInterval(() => {
        ids.forEach((v, k) => {
          if (v) {
            const item = document.getElementById(v);
            item.innerHTML = count + "秒";
            count--;
            if (count <= 0) {
              if (endCb[k]) {
                endCb[k]();
              }
              clearInterval(inter);
            }
          }
        });
      }, 1000);
      window.loginInter = inter;
    }
    return res.data;
  },
  // gitlab重定向登录
  async gitLabLogin() {
    const res = await providerAuthLink("gitlab", "login");
    window.location.href = res.data;
  },
  //微信
  async gitWechatLogin() {
    const res = await providerAuthLink("wechat_open", "login");
    window.location.href = res.data;
  },
  // 百度重定向登录
  async baiduLogin() {
    const res = await providerAuthLink("baidu", "login");
    // console.log('baiduLogin',res.data)
    window.location.href = res.data;
    // console.log(res);
    // let loginType = await reuqestGetLoginLocation();
    // let type = loginType.data['baidu登录'];
    // window.location.href = '.' + type;
  },
  // 百度重定向登录并标记
  async baiduLoginAndMark() {
    await userModule.baiduLogin();
    StorageModule.set("bindbaidu", "true");
  },
  // 更新用户账号
  updateUser({ token, user }) {
    // 临时处理
    if (window.appdispatch) {
      window.appdispatch({ type: "SET_TOKEN", data: token });
      window.appdispatch({ type: "SET_USERINFO", data: user });
      window.appdispatch({ type: "SET_SUBJECTINFO", data: { subjectCatalogue: [], subjectId: user.attachInfo.userTopicDesktop.currentTopicId, data: {} } });
    }
  },
  // 根据用户信息跳转页面，首页逻辑
  async redirectPageByUser(user, history, needinit) {
    let tree = {};
    // try {
    //     tree = await requestAllSyncCatalogue(user.id);
    // } catch (err) {
    // }
    const search = window.location.href.split("?")[1] || "";
    const searchurl = search ? `?${search}` : "";
    history.push(tree.data ? "/view" + searchurl : "/view" + searchurl);
    if (!SocketModule.mainSocket && needinit) {
      window.init();
    }
  },
};
